// App-specific config shape. Hub doesn't add anything beyond the base today;
// it extends `BaseDynamicConfig` so app-specific fields can be added here later
// without touching the shared loader.
import {
  loadConfig as loadBaseConfig,
  getConfig as getBaseConfig,
  type BaseDynamicConfig,
} from '@my/platform/config';

export interface DynamicConfig extends BaseDynamicConfig {
  /**
   * Where each operational app lives, keyed by lower-case app key, for the
   * "open this customer in…" handover. Environment-specific — localhost ports
   * in dev, `https://my.<app>.stratum.ie` in production — which is exactly why
   * it is runtime config rather than a constant.
   *
   * <p>
   * An app missing from this map simply is not offered. Better a button that
   * is not there than one that opens nowhere.
   * </p>
   */
  appUrls?: Record<string, string>;
}

/** Fetch and cache `/config.json`. Call once at boot before render. */
export const loadConfig = (): Promise<DynamicConfig> => loadBaseConfig<DynamicConfig>();

/** Synchronous accessor — throws if `loadConfig()` hasn't resolved yet. */
export const getConfig = (): DynamicConfig => getBaseConfig<DynamicConfig>();
